import type { FC } from 'react'
import type { CellProps } from '../../../interfaces'

type Props = CellProps
const TextCell: FC<Props> = ({ title }) => {
  return (
    <div className='custom-cell'>{title !== 'null' && title !== 'undefined' ? title : '-'}</div>
  )
}

export default TextCell
